<template>
    <CustomHeader :text="$t('vip.title')" />
    <div class="vip-container">
        <div class="vip-banner">
            <img :src="dataSet.bannerIcon" alt="">
            <div class="header-text">{{ dataSet.currentLevel }}</div>
        </div>
        <div class="subContainer">
            <div class="middle-banner">
                <van-row class="toData">
                    <van-col span="16" class="leftDetails">
                        <div class="middle-header-text">{{ $t('vip.receiveBonuses') }}</div>
                        <div class="middle-amount">{{ dataSet.remainRewards }}</div>
                    </van-col>
                    <van-col span="8" style="display: flex; align-items: center; margin-bottom: 15px;">
                        <div class="claimBtn" :class="dataSet.remainRewards == 0 ? 'disableBtn' : ''" @click="VIPClaim">
                            {{
                                $t('activity.reciev') }}</div>
                    </van-col>
                    <van-col span="24">
                        <van-row class="bottomData" @click="showHistory">
                            <van-col span="23" class="leftDetails">
                                <div class="bottomData-text">{{ $t('activity.bonuRegistation') }}</div>
                            </van-col>
                            <van-col span="1" style="color: #FFEE00; font-size: 14px;">
                                <van-icon name="play" />
                            </van-col>
                        </van-row>
                    </van-col>
                </van-row>
            </div>

            <div class="progressCard">
                <van-row style="padding: 10px;">
                    <van-col span="16" style="display: flex; align-items: end;"><span class="card-top">{{
                        $t('vip.bettingValue') }}</span></van-col>
                    <van-col span="8" class="card-top-right"><span>{{ dataSet.VIPRewardsInfo?.betTotal
                            }}</span></van-col>
                    <van-col span="24">
                        <div class="bar">
                            <div class="progress"
                                :style="{ width: dataSet.VIPRewardsInfo?.betTotal / dataSet.nextLevelRecord?.bet_min < 1 ? dataSet.VIPRewardsInfo?.betTotal * 100 / dataSet.nextLevelRecord.bet_min + '%' : '100%' }">
                            </div>
                            <div class="progress-end-dot"
                                :style="{ left: `calc(${dataSet.VIPRewardsInfo?.betTotal * 100 / dataSet.nextLevelRecord?.bet_min}% - 6px)` }">
                            </div>
                        </div>
                    </van-col>
                    <van-col span="16">
                        <span class="card-top-bottom" style="top: 36vh;font-size: 13px;">{{ 0 }}</span>
                    </van-col>
                    <van-col span="8" class="card-top-bottom-right">
                        <span style="color: #DD7A33;top: 36vh;font-size: 13px;">
                            {{ dataSet.nextLevelRecord?.bet_min }}({{ $t('vip.title') }} {{ dataSet.nextLevel }})</span>
                    </van-col>
                </van-row>
                <!-- Today Betting Volume -->
                <van-row class="bettingVolume" v-if="vipConfigData?.rewardsStatus?.isDailyReward === 1">
                    <van-col span="16" style="display: flex; align-items: end;"><span class="card-top">{{
                        $t('vip.dayBetVolume') }}</span></van-col>
                    <van-col span="8" class="card-top-right"><span class="card-top-right">{{
                        dataSet.VIPRewardsInfo?.dailyTotalBet }}</span></van-col>
                    <van-col span="24">
                        <div class="bar">
                            <div class="progress"
                                :style="{ width: dataSet.VIPRewardsInfo?.dailyTotalBet / dataSet.nextLevelRecord?.daily_reward_retention < 1 ? dataSet.VIPRewardsInfo?.dailyTotalBet * 100 / dataSet.nextLevelRecord?.daily_reward_retention + '%' : '100%', background: '#F8D8A7' }">
                            </div>
                            <div class="progress-end-dot"
                                :style="{ left: `calc(${dataSet.VIPRewardsInfo?.dailyTotalBet * 100 / dataSet.nextLevelRecord?.daily_reward_retention}% - 6px)` }">
                            </div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <span class="card-top-bottom">0</span>
                    </van-col>
                    <van-col span="16" class="card-top-bottom-right">
                        <span class="card-top-bottom-right" style="color: #F8D8A7;">
                            {{ $t('vip.division') }}: {{ dataSet.nextLevelRecord?.daily_reward_retention }}
                        </span>
                    </van-col>
                </van-row>

                <!-- Week Betting Volume -->
                <van-row class="bettingVolume" v-if="vipConfigData?.rewardsStatus?.isWeeklyRewards === 1">
                    <van-col span="16" style="display: flex; align-items: end;"><span class="card-top">{{
                        $t('vip.weekBetVolume') }}</span></van-col>
                    <van-col span="8" class="card-top-right"><span class="card-top-right">{{
                        dataSet.VIPRewardsInfo?.weeklyTotalBet }}</span></van-col>
                    <van-col span="24">
                        <div class="bar">
                            <div class="progress"
                                :style="{ width: dataSet.VIPRewardsInfo?.weeklyTotalBet / dataSet.nextLevelRecord?.week_reward_retention < 1 ? dataSet.VIPRewardsInfo?.weeklyTotalBet * 100 / dataSet.nextLevelRecord?.week_reward_retention + '%' : '100%', background: '#F8D8A7' }">
                            </div>
                            <div class="progress-end-dot"
                                :style="{ left: `calc(${dataSet.VIPRewardsInfo?.weeklyTotalBet * 100 / dataSet.nextLevelRecord?.week_reward_retention}% - 6px)` }">
                            </div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <span class="card-top-bottom">{{ 0 }}</span>
                    </van-col>
                    <van-col span="16" class="card-top-bottom-right">
                        <span class="card-top-bottom-right" style="color: #F8D8A7;">
                            {{ $t('vip.division') }}:{{ dataSet.nextLevelRecord?.week_reward_retention }}
                        </span>
                    </van-col>
                </van-row>
                <!-- Monthly betting volume -->
                <van-row class="bettingVolume" v-if="vipConfigData?.rewardsStatus?.isMonthlyRewards === 1">
                    <van-col span="16" style="display: flex; align-items: end;"><span class="card-top">{{
                        $t('vip.monthBetVolume')
                            }}</span></van-col>
                    <van-col span="8" class="card-top-right"><span class="card-top-right">{{
                        dataSet.VIPRewardsInfo?.monthlyTotalBet }}</span></van-col>
                    <van-col span="24">
                        <div class="bar">
                            <div class="progress"
                                :style="{ width: dataSet.VIPRewardsInfo?.monthlyTotalBet / dataSet.nextLevelRecord?.month_reward_retention < 1 ? dataSet.VIPRewardsInfo?.monthlyTotalBet * 100 / dataSet.nextLevelRecord?.month_reward_retention + '%' : '100%', background: '#F8D8A7' }">
                            </div>
                            <div class="progress-end-dot"
                                :style="{ left: `calc(${dataSet.VIPRewardsInfo?.monthlyTotalBet * 100 / dataSet.nextLevelRecord?.month_reward_retention}% - 6px)` }">
                            </div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <span class="card-top-bottom">{{ 0 }}</span>
                    </van-col>
                    <van-col span="16" class="card-top-bottom-right">
                        <span class="card-top-bottom-right" style="color: #F8D8A7;">
                            {{ $t('vip.division') }}: {{ dataSet.nextLevelRecord?.month_reward_retention }}
                        </span>
                    </van-col>
                </van-row>
            </div>
            <div class="tabs">

                <van-tabs id="vipTabs" v-model:active="active">
                    <van-tab v-for="index in tabList" :title="$t(index.name)" :key="index.id">
                    </van-tab>
                </van-tabs>
            </div>

            <VIPTableView :activeNo="dataSet.active" :tableData="dataSet.tabelData"
                :activeData="dataSet.vipConfigData?.rewardsStatus" />

            <div class="bottom_text">
                <van-row style="padding-bottom: 10px;">
                    <van-col span="6">
                        <div class="line1"></div>
                    </van-col>
                    <van-col span="12" class="title">
                        <div>{{ $t('common.activityTitle') }}</div>
                    </van-col>
                    <van-col span="6">
                        <div class="line2"></div>
                    </van-col>
                </van-row>
                <div class="line_text" v-for="(item, index) in dataSet.activity_intro" :key="index" v-html="item">
                </div>
            </div>
        </div>
    </div>
    <VipHistoryPopup ref="historyRef" />
</template>
<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import VIPTableView from './components/vipTableView.vue';
import { computed, ref, defineProps, defineEmits, watch } from 'vue';
import VipHistoryPopup from './components/vipHistoryPopup.vue';
import { VipData } from '@/view/vip/supportScript';
import { TAB_LIST } from '@/view/vip/supportScript';

const progressPercentage = computed(() => 6500 * 100 / 10000);
const active = ref(0);
const historyRef = ref()
const vipConfigData = ref()
const tabList = computed(() => {
    return TAB_LIST
});
const showHistory = () => {
    historyRef.value.open()
}
const props = defineProps<{
    dataSet: VipData,
}>()
const emit = defineEmits(['vIPClaim', 'update:active'])

const VIPClaim = () => {
    emit('vIPClaim')
}
watch(active, (val) => {
    emit('update:active', val)
})


</script>
<style scoped>
.vip-container {
    min-height: 100vh;
}

.vip-banner {
    position: relative;
}

.vip-banner img {
    width: 100%;
}

.header-text {
    position: absolute;
    top: 45%;
    height: 30%;
    left: 0;
    right: 0;
    color: #FFF;
    font-size: 45px;
    font-weight: bold;
    text-shadow: 0 2px 0 #232833;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
}

.subContainer {
    padding: 0 25px 25px;
}

.middle-banner {
    border-radius: 15px;
    white-space: nowrap;
}

.toData {
    background-image: linear-gradient(to bottom, #835226, #37200e);
    padding: 25px 0 0;
    border-radius: 15px;
}

.middle-header-text {
    color: #FFF;
    font-size: 17px;
    text-align: left;
    padding: 5px 15px;
}

.middle-amount {
    color: #FFEE00;
    font-size: 40px;
    text-align: left;
    font-weight: bold;
    padding: 5px 15px 25px;
}

.claimBtn {
    color: #2b323d;
    font-size: 13px;
    background-image: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;
    padding: 15px 0;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 90%;
    font-weight: bold;
}

.disableBtn {
    background-image: linear-gradient(rgb(248 216 167 / 18%) 0%, rgb(240 168 83 / 14%) 100%);
    color: #717171ad;
}

.bottomData {
    background-image: linear-gradient(to bottom, #664c35, #76461b);
    padding: 10px;
    border-radius: 0 0 15px 15px;
}

.bottomData-text {
    font-size: 13px;
    color: #fff;
    padding-left: 15px;
}

.right-btn {
    width: 100%;
}

.progressCard {
    position: relative;
    margin-top: 10px;
    background: #3e2b21;
    border-radius: 15px;
    border: 2px solid orange;
    border-left: none;
    border-right: none;
    padding: 15px;
}

.card-top {
    color: #ffffffd9;
    font-size: 13px;
    text-align: center;
    white-space: nowrap;
}

.card-top-right {
    color: #ffffffd9;
    font-size: 18px;
    text-align: right;
    white-space: nowrap;
}

.bar {
    position: relative;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    height: 8px;
    width: 100%;
    margin: 10px 0;
}

.progress {
    background: #F0A853;
    border-radius: 10px;
    height: 8px;
}

.progress-end-dot {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;
    z-index: 2;
}

.cur-frame {
    height: 0.62rem;
    background: #DD7A33;
    border-radius: 0.34rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 5px 0;
}

.card-top-bottom {
    color: #ffffffd9;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
}

.card-top-bottom-right {
    color: #ffffffd9;
    font-size: 12px;
    text-align: right;
    white-space: nowrap;
}

.bettingVolume {
    padding: 10px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 15px;
    margin-top: 10px;
}

.tabs {
    margin-top: 15px;
}

.activity-text {
    color: #f9c48680;
    text-align: left;
    white-space: pre-wrap;
    font-size: 14px;
    padding-bottom: 20px;
}

.activity-title-row {
    display: flex;
    align-items: center;
    margin: 30px 0px 20px;
}

.left-img {
    background-image: linear-gradient(90deg, rgba(249, 196, 134, 0.00) 0%, rgba(249, 196, 134, 0.50) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-right: 0.2rem;
}

.activity-title {
    color: #f9c48680;
    font-size: 15px;
    display: flex;
    justify-content: center
}

.right-img {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(249, 196, 134, 0.00) 0%, rgba(249, 196, 134, 0.50) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-left: 0.2rem;
}

.bottom_text {
    padding: 30px 0 0;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}





.cur-frame-point {
    width: 0.62rem;
    height: 0.62rem;
    background: #FFFFFF;
    border-radius: 0.34rem;
}

::v-deep #vipTabs {
    --van-tabs-nav-background: transparent !important;
}

::v-deep #vipTabs .van-tab--active {
    --van-tab-active-text-color: #FCD7A1 !important;
    border-bottom: 2px solid #FCD7A1 !important;
}

::v-deep #vipTabs .van-tab {
    --van-tab-text-color: #ffffffD9 !important;
}

::v-deep #vipTabs .van-tabs__line {
    display: none;
}
</style>